import styled from 'styled-components';
import { InputField, Checkbox } from '@cashfree-intl/coherent';

export const StyledDropdown = styled.div`
  & > div {
    background-color: #fff !important;
    margin-bottom: 0 !important;
    .divider.text {
      margin: 0;
    }
  }
`;

export const StyledSection = styled.div``;

export const StyledInputField = styled(InputField)`
  .ui.fluid.input {
    margin-bottom: 0 !important;
    width: 20rem;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  min-height: unset !important;
  margin-bottom: 1rem;
`;
